import { IServerResponse } from "app/interface";

export interface CommodityState {
    commodityList: Array<any>;
    commodityByFieldList: Array<any>;
    commodityById: any;
    addCommodityResp: IServerResponse;
    updateCommodityResp: IServerResponse;
    deleteCommodityResp: IServerResponse;
    linkByAssetId: Array<any>;
    commodityLinkedToContractId: any;
    costTrackerContractsByCommodityId: Array<any>;
}

export const initialState: CommodityState = {
    commodityList: null,
    commodityByFieldList: null,
    commodityById: null,
    addCommodityResp: null,
    updateCommodityResp: null,
    deleteCommodityResp: null,
    linkByAssetId: [],
    commodityLinkedToContractId: null,
    costTrackerContractsByCommodityId: null
}
